import { createSlice } from "@reduxjs/toolkit";
import { DEFAULT_LANGUAGE } from "constants";
import {
  getFacts,
  getImportantLinks,
  getNews,
  getPublicPages,
  getSettings,
  getSlides,
  getSocialMediaLinks,
} from "./actions";

const initialState = {
  // line 14 initial State for app store
  language: DEFAULT_LANGUAGE,
  slides: {
    data: [],
    loading: false,
  },
  news: {
    data: [],
    loading: false,
  },
  facts: {
    data: [],
    loading: false,
  },
  socialMediaLinks: {
    data: [],
    loading: false,
  },
  publicPages: {
    data: [],
    loading: false,
  },
  importantLinks: {
    data: [],
    loading: false,
  },
  settings: {
    loading: false,
  },
};

const appSlice = createSlice({ // line 45 using @reduxjs/toolkit createSlice build store
  name: "app",
  initialState,
  reducers: { // line 48 appSlice reducers
    switchLanguage: (state, action) => { // line 49 switchLanguage to set new language to app store
      state.language = action.payload;
    },
  },
  extraReducers: { // extra Reducers to listens to async function out the slice
    // Slides
    [getSlides.pending]: (state, action) => { // getSlides set app state slides loading
      state.slides.loading = true;
    },
    [getSlides.fulfilled]: (state, action) => { // getSlides set app state slides loading and data 
      state.slides.loading = false;
      state.slides.data = action.payload;
    },
    [getSlides.rejected]: (state, action) => { // getSlides set app state slides loading 
      state.slides.loading = false;
    },

    // News
    [getNews.pending]: (state, action) => { // getNews set app state news loading
      state.news.loading = true;
    },
    [getNews.fulfilled]: (state, action) => { // getNews set app state news loading and data 
      state.news.loading = false;
      state.news.data = action.payload;
    },
    [getNews.rejected]: (state, action) => { // getNews set app state news loading
      state.news.loading = false;
    },

    // Facts
    [getFacts.pending]: (state, action) => { // getFacts set app state facts loading
      state.facts.loading = true;
    },
    [getFacts.fulfilled]: (state, action) => { // getFacts set app state facts loading and data 
      state.facts.loading = false;
      state.facts.data = action.payload;
    },
    [getFacts.rejected]: (state, action) => { // getFacts set app state facts loading
      state.facts.loading = false;
    },

    // SocialMediaLinks
    [getSocialMediaLinks.pending]: (state, action) => { // getSocialMediaLinks set app state socialMediaLinks loading
      state.socialMediaLinks.loading = true;
    },
    [getSocialMediaLinks.fulfilled]: (state, action) => { // getSocialMediaLinks set app state socialMediaLinks loading and data 
      state.socialMediaLinks.loading = false;
      state.socialMediaLinks.data = action.payload;
    },
    [getSocialMediaLinks.rejected]: (state, action) => { // getSocialMediaLinks set app state socialMediaLinks loading
      state.socialMediaLinks.loading = false;
    },

    // Public Pages
    [getPublicPages.pending]: (state, action) => { // getPublicPages set app state publicPages loading
      state.publicPages.loading = true;
    },
    [getPublicPages.fulfilled]: (state, action) => { // getPublicPages set app state publicPages loading and data 
      state.publicPages.loading = false;
      state.publicPages.data = action.payload;
    },
    [getPublicPages.rejected]: (state, action) => { // getPublicPages set app state publicPages loading
      state.publicPages.loading = false;
    },

    // Important Links
    [getImportantLinks.pending]: (state, action) => { // getImportantLinks set app state importantLinks loading
      state.importantLinks.loading = true;
    },
    [getImportantLinks.fulfilled]: (state, action) => { // getImportantLinks set app state importantLinks loading and data 
      state.importantLinks.loading = false;
      state.importantLinks.data = action.payload;
    },
    [getImportantLinks.rejected]: (state, action) => { // getImportantLinks set app state importantLinks loading
      state.importantLinks.loading = false;
    },

    // Settings
    [getSettings.pending]: (state, action) => { // getSettings set app state settings loading
      state.settings.loading = true;
    },
    [getSettings.fulfilled]: (state, action) => { // getSettings set app state settings loading and data 
      state.settings.loading = false;
      state.settings = { ...state.settings, ...action.payload };
    },
    [getSettings.rejected]: (state, action) => { // getSettings set app state settings loading
      state.settings.loading = false;
    },
  },
});

export { getSlides, getNews, getFacts };
export const { switchLanguage } = appSlice.actions;
export default appSlice.reducer;
